import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import markNotifyAsReadHandler from "./mark-notify-as-read.handler";
import { INotify, NotifyType } from "../../model/user-info.interface";
import { login } from "../user/login.handler";
import { loginFulfilledForNotificationsHandler } from "./login-notifications.handler";
import getNotificationsHandler from "./get-notifications.handler";
import { CustomNotifyType } from "../../components/Modal/ModalNotify/Custom/CustomNotifyRouter";

export interface INotificationsState extends IRequestState {
    items: INotify[];
};

const initialState: INotificationsState = {
    items: [],

    loading: false,
    error: "",
};

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        removeNotifyById: (state, action: PayloadAction<number>) => {
            state.items = state.items.filter(item => item.id !== action.payload);
        },
        addCustomNotify: (state, action: PayloadAction<CustomNotifyType>) => {
            const notify = {
                type: NotifyType.Custom,
                customType: action.payload,
            }
            state.items.push(notify as unknown as INotify);
        },
        addNotifications: (state, action: PayloadAction<INotify[]>) => {
            state.items.push(...action.payload);
        },
        customizeNotify: (state, action: PayloadAction<{ id: number, type: CustomNotifyType }>) => {
            const notify = state.items.find(item => item.id === action.payload.id);
            if (notify) {
                notify.customType = action.payload.type;
            }
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<INotificationsState>) => {
        getNotificationsHandler(builder);
        markNotifyAsReadHandler(builder);

        builder.addCase(login.fulfilled, loginFulfilledForNotificationsHandler);
    },
});

export default notificationsSlice.reducer;
export const { removeNotifyById, addCustomNotify, addNotifications, customizeNotify } = notificationsSlice.actions;